module.exports = [
	{
		"fund_family_label": "Vanguard",
		"as_of": "202504",
		"fund_id": 186,
		"net_asset_sum": 9647752344320,
		"long_asset_sum": 9812876652174,
		"num_equity_funds": 103,
		"equity_fund_net_assets": 7011903280027,
		"equity_fund_long_assets": 7013713520479,
		"num_e_sri": 6,
		"num_e_usf": 0,
		"sri_long_assets": 39533795477,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 38714367492,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 538,
		"df_producer_asset_sum": 22959912013,
		"df_financier_count_sum": 401,
		"df_financier_asset_sum": 183085846252,
		"df_consumer_count_sum": 2055,
		"df_consumer_asset_sum": 659835817103,
		"df_all_count_sum": 2805,
		"df_all_asset_sum": 854095005244,
		"df_all_weight_total": 0.12177500588670605,
		"climate_asset_sum": 600144068753,
		"ff_all_asset_sum": 585242035965,
		"sri_climate_asset_sum": 365771255,
		"sri_with_most_climate_asset": 179375758,
		"name": "Vanguard",
		"fund_family_name": "Vanguard",
		"label": "Vanguard"
	},
	{
		"fund_family_label": "BlackRock/iShares",
		"as_of": "202504",
		"fund_id": 599,
		"net_asset_sum": 3671465179458,
		"long_asset_sum": 3897415182946,
		"num_equity_funds": 314,
		"equity_fund_net_assets": 2483438621625,
		"equity_fund_long_assets": 2498281455711,
		"num_e_sri": 38,
		"num_e_usf": 0,
		"sri_long_assets": 58774322678,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 48731644806,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 950,
		"df_producer_asset_sum": 11119301931,
		"df_financier_count_sum": 928,
		"df_financier_asset_sum": 69198472974,
		"df_consumer_count_sum": 3792,
		"df_consumer_asset_sum": 211166223173,
		"df_all_count_sum": 5332,
		"df_all_asset_sum": 286334485556,
		"df_all_weight_total": 0.11461258094096946,
		"climate_asset_sum": 233496486844,
		"ff_all_asset_sum": 227044578184,
		"sri_climate_asset_sum": 3412814432,
		"sri_with_most_climate_asset": 964360316,
		"name": "BlackRock/iShares",
		"fund_family_name": "BlackRock/iShares",
		"label": "BlackRock/iShares"
	},
	{
		"fund_family_label": "American Funds/Capital Group",
		"as_of": "202504",
		"fund_id": 95,
		"net_asset_sum": 2830778281503,
		"long_asset_sum": 2840990811942,
		"num_equity_funds": 35,
		"equity_fund_net_assets": 2104804825452,
		"equity_fund_long_assets": 2108233696915,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 65,
		"df_producer_asset_sum": 8997821790,
		"df_financier_count_sum": 136,
		"df_financier_asset_sum": 47155299096,
		"df_consumer_count_sum": 405,
		"df_consumer_asset_sum": 133960464443,
		"df_all_count_sum": 583,
		"df_all_asset_sum": 188042543584,
		"df_all_weight_total": 0.08919435443004473,
		"climate_asset_sum": 160225204194,
		"ff_all_asset_sum": 157093594067,
		"sri_climate_asset_sum": 0,
		"sri_with_most_climate_asset": 0,
		"name": "American Funds/Capital Group",
		"fund_family_name": "American Funds/Capital Group",
		"label": "American Funds/Capital Group"
	},
	{
		"fund_family_label": "Fidelity Investments",
		"as_of": "202504",
		"fund_id": 546,
		"net_asset_sum": 3931832663313,
		"long_asset_sum": 4007479229896,
		"num_equity_funds": 305,
		"equity_fund_net_assets": 2668237275935,
		"equity_fund_long_assets": 2679893054448,
		"num_e_sri": 21,
		"num_e_usf": 0,
		"sri_long_assets": 8247782105,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 7209733505,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 699,
		"df_producer_asset_sum": 7452884117,
		"df_financier_count_sum": 806,
		"df_financier_asset_sum": 59537555089,
		"df_consumer_count_sum": 3336,
		"df_consumer_asset_sum": 234805940113,
		"df_all_count_sum": 4591,
		"df_all_asset_sum": 298930866925,
		"df_all_weight_total": 0.11154581949785056,
		"climate_asset_sum": 208325019515,
		"ff_all_asset_sum": 203631217620,
		"sri_climate_asset_sum": 267959160,
		"sri_with_most_climate_asset": 112849218,
		"name": "Fidelity Investments",
		"fund_family_name": "Fidelity Investments",
		"label": "Fidelity Investments"
	},
	{
		"fund_family_label": "State Street",
		"as_of": "202504",
		"fund_id": 191,
		"net_asset_sum": 1556452674765,
		"long_asset_sum": 1556850117249,
		"num_equity_funds": 107,
		"equity_fund_net_assets": 1250049521557,
		"equity_fund_long_assets": 1250051252209,
		"num_e_sri": 6,
		"num_e_usf": 0,
		"sri_long_assets": 2147073258,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 2105946916,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 481,
		"df_producer_asset_sum": 3761879533,
		"df_financier_count_sum": 368,
		"df_financier_asset_sum": 32466084955,
		"df_consumer_count_sum": 1691,
		"df_consumer_asset_sum": 130675814426,
		"df_all_count_sum": 2365,
		"df_all_asset_sum": 164456479915,
		"df_all_weight_total": 0.13155978974812788,
		"climate_asset_sum": 149864374229,
		"ff_all_asset_sum": 146542251917,
		"sri_climate_asset_sum": 137314245,
		"sri_with_most_climate_asset": 95701231,
		"name": "State Street",
		"fund_family_name": "State Street",
		"label": "State Street"
	},
	{
		"fund_family_label": "Schwab Funds",
		"as_of": "202504",
		"fund_id": 94,
		"net_asset_sum": 630638407236,
		"long_asset_sum": 630772726103,
		"num_equity_funds": 43,
		"equity_fund_net_assets": 549455443635,
		"equity_fund_long_assets": 549475341866,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 25878101,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 25878101,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 224,
		"df_producer_asset_sum": 3027078535,
		"df_financier_count_sum": 179,
		"df_financier_asset_sum": 13473200164,
		"df_consumer_count_sum": 1065,
		"df_consumer_asset_sum": 54925618063,
		"df_all_count_sum": 1374,
		"df_all_asset_sum": 69740864850,
		"df_all_weight_total": 0.12692264699843006,
		"climate_asset_sum": 60201180389,
		"ff_all_asset_sum": 58294633934,
		"sri_climate_asset_sum": 653171,
		"sri_with_most_climate_asset": 653171,
		"name": "Schwab Funds",
		"fund_family_name": "Schwab Funds",
		"label": "Schwab Funds"
	},
	{
		"fund_family_label": "T. Rowe Price",
		"as_of": "202504",
		"fund_id": 174,
		"net_asset_sum": 931684621075,
		"long_asset_sum": 936781693163,
		"num_equity_funds": 77,
		"equity_fund_net_assets": 624564668458,
		"equity_fund_long_assets": 625608414117,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 23705680,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 23705680,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 92,
		"df_producer_asset_sum": 2338928506,
		"df_financier_count_sum": 186,
		"df_financier_asset_sum": 11012133589,
		"df_consumer_count_sum": 665,
		"df_consumer_asset_sum": 42307554479,
		"df_all_count_sum": 911,
		"df_all_asset_sum": 55188501267,
		"df_all_weight_total": 0.08821572731705421,
		"climate_asset_sum": 44292595665,
		"ff_all_asset_sum": 42293765842,
		"sri_climate_asset_sum": 738471,
		"sri_with_most_climate_asset": 738471,
		"name": "T. Rowe Price",
		"fund_family_name": "T. Rowe Price",
		"label": "T. Rowe Price"
	},
	{
		"fund_family_label": "Thrift Savings Plan",
		"as_of": "202504",
		"fund_id": 14,
		"net_asset_sum": 755500000039,
		"long_asset_sum": 757832553640,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 517100000012,
		"equity_fund_long_assets": 518776815174,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 18,
		"df_producer_asset_sum": 1708657494,
		"df_financier_count_sum": 24,
		"df_financier_asset_sum": 15369173620,
		"df_consumer_count_sum": 112,
		"df_consumer_asset_sum": 49973812003,
		"df_all_count_sum": 145,
		"df_all_asset_sum": 66185874212,
		"df_all_weight_total": 0.1275806325111136,
		"climate_asset_sum": 45703341856,
		"ff_all_asset_sum": 44842412573,
		"sri_climate_asset_sum": 0,
		"sri_with_most_climate_asset": 0,
		"name": "Thrift Savings Plan",
		"fund_family_name": "Thrift Savings Plan",
		"label": "Thrift Savings Plan"
	},
	{
		"fund_family_label": "TIAA Investments/Nuveen",
		"as_of": "202504",
		"fund_id": 165,
		"net_asset_sum": 685423802061,
		"long_asset_sum": 686251325012,
		"num_equity_funds": 62,
		"equity_fund_net_assets": 446932544290,
		"equity_fund_long_assets": 446956470956,
		"num_e_sri": 15,
		"num_e_usf": 1,
		"sri_long_assets": 44237494489,
		"usf_long_assets": 13791506071,
		"equity_fund_sri_long_assets": 36714570658,
		"equity_fund_usf_long_assets": 7062666990,
		"sustainable_manager": 0,
		"df_producer_count_sum": 205,
		"df_producer_asset_sum": 1626463535,
		"df_financier_count_sum": 183,
		"df_financier_asset_sum": 12590029873,
		"df_consumer_count_sum": 804,
		"df_consumer_asset_sum": 42966106222,
		"df_all_count_sum": 1126,
		"df_all_asset_sum": 56629997278,
		"df_all_weight_total": 0.12670137017341643,
		"climate_asset_sum": 33397898663,
		"ff_all_asset_sum": 32786313199,
		"sri_climate_asset_sum": 1107490206,
		"sri_with_most_climate_asset": 448330050,
		"name": "TIAA Investments/Nuveen",
		"fund_family_name": "TIAA Investments/Nuveen",
		"label": "TIAA Investments/Nuveen"
	},
	{
		"fund_family_label": "Invesco",
		"as_of": "202504",
		"fund_id": 327,
		"net_asset_sum": 967057187287,
		"long_asset_sum": 986685546990,
		"num_equity_funds": 198,
		"equity_fund_net_assets": 732559791309,
		"equity_fund_long_assets": 735447184083,
		"num_e_sri": 14,
		"num_e_usf": 0,
		"sri_long_assets": 9471245717,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 6718099287,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"df_producer_count_sum": 191,
		"df_producer_asset_sum": 1500361976,
		"df_financier_count_sum": 247,
		"df_financier_asset_sum": 6923561257,
		"df_consumer_count_sum": 1280,
		"df_consumer_asset_sum": 71016385528,
		"df_all_count_sum": 1616,
		"df_all_asset_sum": 78376219283,
		"df_all_weight_total": 0.1065694736199503,
		"climate_asset_sum": 51982318484,
		"ff_all_asset_sum": 50529988326,
		"sri_climate_asset_sum": 247979653,
		"sri_with_most_climate_asset": 137917426,
		"name": "Invesco",
		"fund_family_name": "Invesco",
		"label": "Invesco"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/FamilyFunds.json
// module id = 948
// module chunks = 0